export const emptyTextValidationDirective = () => {
	return {
		require: 'ngModel',
		restrict: 'A',
		link: (scope, element, attrs, ngModel) => {
			ngModel.$parsers.push((value) => {
                var modifiedInput = value;
                modifiedInput = modifiedInput.replace(/^ +/g, '');
                if (modifiedInput != value) {
                    ngModel.$setViewValue(modifiedInput);
                    ngModel.$render();
                }
                scope.$watch(ngModel, () => {
                    if (ngModel.$viewValue == "") {
                        ngModel.$$parsedNgModelAssign(scope, '');
                    }
                });
                return modifiedInput;
            });
            
		}
	};
};


// WEBPACK FOOTER //
// ./src/app/common/components/empty-text-validation/empty-text-validation.directive.js